import { useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/BarakaLogo.png";
import "./navBar.css";
import { Smartphone } from "lucide-react";
import DownloadModal from "../downloadModal/downloadModal";
import LanguageSwitcher from "../languageSwitcher/languageSwitcher";

// ── Web-app imports (kept for future use) ──
// import { useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import { UserContext } from "../../context/userContext";
// ──────────────────────────────────────────

const NavBar = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // const { user } = useContext(UserContext); // restored when web-app mode returns

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      <DownloadModal open={modalOpen} setOpen={setModalOpen} />

      <nav className="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-gray-200 dark:border-gray-600">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          {/* Logo — links to home */}
          <a
            href="/"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img src={logo} className="h-15" alt="Baraka Logo" />
          </a>

          {/* Right-side buttons */}
          <div className="flex items-center md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse gap-2">
            <LanguageSwitcher className="hidden sm:inline-flex" />

            <button
              type="button"
              onClick={() => setModalOpen(true)}
              className="flex items-center gap-2 bg-primary text-white font-medium rounded-xl text-sm px-4 py-2 text-center transition-all duration-200 hover:bg-primary-dark hover:scale-105"
            >
              <Smartphone className="w-4 h-4" />
              <span className="hidden sm:inline">{t("nav.downloadApp")}</span>
            </button>

            <button
              data-collapse-toggle="navbar-sticky"
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-sticky"
              aria-expanded={menuOpen}
              onClick={toggleMenu}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
          </div>

          {/* Nav links */}
          <div
            className={`items-center justify-between w-full md:flex md:w-auto md:order-1 ${
              menuOpen ? "block" : "hidden"
            }`}
            id="navbar-sticky"
          >
            <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
              <li>
                <a
                  href="/"
                  className="block py-2 px-3 text-dark-grey rounded hover:bg-light-grey md:hover:bg-transparent md:p-0 nav-link"
                >
                  {t("nav.home")}
                </a>
              </li>
              <li>
                <a
                  href="#/auctions"
                  className="block py-2 px-3 text-dark-grey rounded hover:bg-light-grey md:hover:bg-transparent md:p-0 nav-link"
                >
                  {t("nav.auctions")}
                </a>
              </li>
              <li>
                <a
                  href="#/aboutUs"
                  className="block py-2 px-3 text-dark-grey rounded hover:bg-light-grey md:hover:bg-transparent md:p-0 nav-link"
                >
                  {t("nav.aboutUs")}
                </a>
              </li>
              <li>
                <a
                  href="#/privacy"
                  className="block py-2 px-3 text-dark-grey rounded hover:bg-light-grey md:hover:bg-transparent md:p-0 nav-link"
                >
                  {t("nav.privacy")}
                </a>
              </li>
              <li>
                <a
                  href="#/terms"
                  className="block py-2 px-3 text-dark-grey rounded hover:bg-light-grey md:hover:bg-transparent md:p-0 nav-link"
                >
                  {t("nav.terms")}
                </a>
              </li>
              {/* Mobile-only language switcher */}
              <li className="block md:hidden mt-2">
                <LanguageSwitcher />
              </li>
              {/* Mobile-only download button */}
              <li className="block md:hidden">
                <button
                  onClick={() => {
                    setMenuOpen(false);
                    setModalOpen(true);
                  }}
                  className="block py-2 px-3 text-primary font-semibold nav-link"
                >
                  {t("nav.downloadApp")}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
